import { JSX, ReactElement, ReactNode, RefObject, useRef } from "react";
import { CSSTransition, SwitchTransition } from "react-transition-group";

import { transitionProps } from "@/config/transition.ts";

import "./GroupTransition.css";

interface GroupTransitionProps<T> {
  transitionKey: string | number | null;
  children: ReactNode | ((props: { ref: RefObject<T> }) => ReactElement);
  disableTranstion?: boolean;
  onEnter?: () => void;
  onEntered?: () => void;
  className?: string;
}

const GroupTransition = <T,>({
  transitionKey,
  children,
  disableTranstion,
  onEnter,
  onEntered,
  className,
}: GroupTransitionProps<T>): JSX.Element => {
  const ref = useRef<T>(null);

  const renderChildren = (ref: RefObject<T>) => (typeof children === "function" ? children({ ref }) : children);

  if (disableTranstion) {
    return <>{renderChildren(ref)}</>;
  }

  return (
    <SwitchTransition>
      <CSSTransition
        nodeRef={ref as RefObject<HTMLElement>}
        key={transitionKey}
        timeout={transitionProps.timeout}
        classNames={className || transitionProps.classNames}
        onExit={onEnter}
        onEnter={onEntered}
        unmountOnExit
      >
        {renderChildren(ref)}
      </CSSTransition>
    </SwitchTransition>
  );
};

export default GroupTransition;
